// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"e979c46c","141":"5f3f0a4c","154":"1975d489","170":"2db801ab","220":"0b9bd9a3","276":"0d6c7f35","345":"e93c13b1","488":"77506a48","837":"0a0ec269"}[chunkId] + ".chunk.js";
};